import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AmplitudeService } from '../../shared/services/amplitude.service';

@Component({
  selector: 'cc-legacy-single-integration',
  templateUrl: './legacy-single-integration.component.html',
  styleUrls: ['./legacy-single-integration.component.scss']
})

// TODO remove in March 2021 when no invocation reported from support
export class LegacySingleIntegrationComponent implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute, private amplitudeService: AmplitudeService) {}

  ngOnInit() {
    const platformType = this.route.snapshot.paramMap.get('integratedPlatformType');

    this.amplitudeService.logEvent('Panel:Integrations: Legacy view. Contact tech to remove usage', { platformType });
    this.router.navigateByUrl(`integrations/${platformType}`);
  }
}
